import type { Dayjs } from 'dayjs'

export const useStudentSchoolYears = (
  student?: MaybeRef<{
    created_at: string
    school_class: { enrolment_year: number }
  }>,
) => {
  const dayjs = useDayjs()
  const cms = useCmsStore()

  const startSchoolDate = dayjs(cms.globals?.general.schoolYearStartDate)

  function getSchoolYearFrom(date: string | number | Date | Dayjs) {
    const day = dayjs(date)
    let year = day.year()

    if (
      day.month() < startSchoolDate.month()
      || (day.month() === startSchoolDate.month()
        && day.date() < startSchoolDate.date())
    ) {
      year -= 1
    }

    return year
  }

  const currentYear = computed(() => getSchoolYearFrom(dayjs()))

  const years = computed(() => {
    const sus = unref(student)
    if (!sus?.created_at) {
      return []
    }

    const firstYear = getSchoolYearFrom(sus.created_at)

    const _currentYear = unref(currentYear)

    const years = []
    for (let year = firstYear; year <= _currentYear; year++) {
      years.push(year)
    }

    return years
  })

  const currentSchoolYear = computed(() => {
    const sus = unref(student)
    if (!sus?.school_class?.enrolment_year || !currentYear.value) {
      return 0
    }

    return currentYear.value - sus.school_class?.enrolment_year
  })

  const isLowerGrade = computed(() => {
    return currentSchoolYear.value /* 0-2 (because 0 based) */ < 3
  })

  return {
    startSchoolDate,
    years,
    currentYear,
    getSchoolYearFrom,
    currentSchoolYear,
    isLowerGrade,
  }
}
